// src/store/features/message/messageSlice.js:
import {
  ADD_MESSAGE,
  RECEIVE_MESSAGE,
  LOAD_MESSAGES,
  LOAD_MESSAGES_SUCCESS,
  LOAD_MESSAGES_FAIL,
  AUTH_SIGNOUT_SUCCESS,
  UPDATE_MESSAGE,
  DELETE_MESSAGE,
  DELETE_CHAT,
  DELETE_ALL_CHATS,
  SET_SELECTED_CHAT,
  SET_IS_NEW_CHAT,
  SET_IS_CHAT_FROM_RECENT_CHAT,
  GENERATE_PDF,
  RESET_GENERATE_PDF,
  CLEAR_ALL_CHAT
} from "./messageTypes";

const initialState = {
  loaded: false,
  chats: [], // Now an array
  recentChats: [],
  fetchHistory: [],
  selectedChatId: null,
  isNewChat: false,
  isChatFromRecentChat: false,
  pdfChatId: null,
};

export default function messages(state = initialState, action) {
  switch (action.type) {
    case ADD_MESSAGE:
    case RECEIVE_MESSAGE: {
      const { chatId } = action.message;

      const existingIndex = state.chats.findIndex((c) => c.chatId === chatId);
      const existingChat = state.chats[existingIndex];

      let updatedChat;
      if (existingChat) {
        const exists = existingChat.chatList.some(
          (msg) => msg.id === action.message.id
        );
        const updatedMessages = exists
          ? existingChat.chatList
          : [...existingChat.chatList, action.message];

        updatedChat = { ...existingChat, chatList: updatedMessages };
      } else {
        updatedChat = {
          chatId,
          chatList: [action.message],
        };
      }

      const newChats = existingChat
        ? [
            ...state.chats.slice(0, existingIndex),
            updatedChat,
            ...state.chats.slice(existingIndex + 1),
          ]
        : [...state.chats, updatedChat];

      return {
        ...state,
        chats: newChats,
        recentChats: [
          chatId,
          ...state.recentChats.filter((id) => id !== chatId),
        ],
      };
    }

    case UPDATE_MESSAGE: {
      const { chatId, messageId, updatedFields } = action.payload;
      const chatIndex = state.chats.findIndex((c) => c.chatId === chatId);
      if (chatIndex === -1) return state;

      const updatedChat = {
        ...state.chats[chatIndex],
        chatList: state.chats[chatIndex].chatList.map((msg) =>
          msg.id === messageId ? { ...msg, ...updatedFields } : msg
        ),
      };

      return {
        ...state,
        chats: [
          ...state.chats.slice(0, chatIndex),
          updatedChat,
          ...state.chats.slice(chatIndex + 1),
        ],
      };
    }

    case DELETE_MESSAGE: {
      const { chatId, messageId } = action;
      const chatIndex = state.chats.findIndex((c) => c.chatId === chatId);
      if (chatIndex === -1) return state;

      const updatedChat = {
        ...state.chats[chatIndex],
        chatList: state.chats[chatIndex].chatList.filter(
          (msg) => msg.id !== messageId
        ),
      };

      return {
        ...state,
        chats: [
          ...state.chats.slice(0, chatIndex),
          updatedChat,
          ...state.chats.slice(chatIndex + 1),
        ],
      };
    }

    case DELETE_CHAT: {
      return {
        ...state,
        chats: state.chats.filter((c) => c.chatId !== action.chatId),
        recentChats: state.recentChats.filter((id) => id !== action.chatId),
        selectedChatId:
          state.selectedChatId === action.chatId ? null : state.selectedChatId,
      };
    }

    case LOAD_MESSAGES:
      return { ...state, loading: true };

    case LOAD_MESSAGES_SUCCESS: {
      const messages = action.json;
      const chatId = action.channel;

      const chatIndex = state.chats.findIndex((c) => c.chatId === chatId);
      const updatedChat = {
        chatId,
        chatList: messages,
      };

      const updatedChats =
        chatIndex !== -1
          ? [
              ...state.chats.slice(0, chatIndex),
              updatedChat,
              ...state.chats.slice(chatIndex + 1),
            ]
          : [...state.chats, updatedChat];

      return {
        ...state,
        loading: false,
        loaded: true,
        fetchHistory: [
          ...state.fetchHistory,
          { lastFetch: action.date, channelName: chatId },
        ],
        chats: updatedChats,
        recentChats: [
          chatId,
          ...state.recentChats.filter((id) => id !== chatId),
        ],
      };
    }

    case LOAD_MESSAGES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case SET_SELECTED_CHAT:
      return {
        ...state,
        selectedChatId: action.chatId,
      };

    case SET_IS_NEW_CHAT:
      return {
        ...state,
        isNewChat: action.payload,
      };

    case SET_IS_CHAT_FROM_RECENT_CHAT:
      return {
        ...state,
        isChatFromRecentChat: action.payload,
      };

    case GENERATE_PDF:
      return {
        ...state,
        pdfChatId: action.payload,
      };

    case RESET_GENERATE_PDF:
      return {
        ...state,
        pdfChatId: null,
      };

    case DELETE_ALL_CHATS:
    case CLEAR_ALL_CHAT:
      return {
        ...state,
        chats: [],
        recentChats: [],
        selectedChatId: null,
        pdfChatId: null,
        isNewChat: false,
        isChatFromRecentChat: false,
        fetchHistory: [],
      };

    case AUTH_SIGNOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
}
